<template>
    <div class="follow-list-module">
        <ModuleTitle title="推荐关注" :type="2"></ModuleTitle>
        <div class="follow-list g-flex-center-center">
            <div class="list-item follow-item-bg" v-for="item in store.followList" :key="item.uid" @click="jumpToAuthor(item)">
                <img class="list-item-img" :src="item.avatar" alt="" />
                <p class="list-item-name">{{ item.nickname }}</p>
                <p class="list-item-tag">官方</p>
                <div class="list-item-btn g-flex-center-center" :class="item.follow_status === '0' ? 'button-2' : 'button-5'" @click.stop="onFollow(item)">
                    <p>{{ item.follow_status === '0' ? '+关注' : '已关注' }}</p>
                </div>
            </div>
        </div>
        <p class="bottom-tip">本页面素材含AI生成内容<span v-if="storeCommon.systemInfo.isIos"> | 本活动与设备制作商Apple Inc.无关</span></p>
        <QSlogan client="freereader" skin="dark"></QSlogan>
    </div>
</template>
<script lang="ts" setup>
import { ref, getCurrentInstance } from 'vue';
import { QSlogan } from '@q-front-npm/h5-ui';
import ModuleTitle from '../module-title/index.vue';
import { useStore } from '@/store';
import { toAuthor, openLogin } from '@q-front-npm/jsbridge';
import { apiFollow } from '@/http/api';
import { useStoreCommon } from '@common/store/common';
const store = useStore();
const instance = getCurrentInstance();
const storeCommon = useStoreCommon();
const jumpToAuthor = (item: any) => {
    toAuthor(item.uid, { tab: '7', });
};

const onFollow = async(item: any) => {
    if (store.indexData.isBlankUser) {
        openLogin();
        return;
    }
    if (item.follow_status === '1') {
        return;
    }
    await apiFollow(item.uid);
    item.follow_status = '1';
    instance!.proxy.$toast('关注成功');
};
</script>
<style lang="scss" scoped>
.follow-list {
    margin-top: -40px;
}
.list-item {
    padding: 76px 20px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &-img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
    }
    &-name {
        font-size: 28px;
        color: #ffffff;
        line-height: 34px;
        margin-top: 16px;
        text-align: center;
    }
    &-tag {
        margin-top: 16px;
        background: rgba(20, 60, 169, 0.31);
        border-radius: 6px;
        font-weight: 500;
        font-size: 19px;
        color: #ffffff;
        line-height: 1;
        padding: 4px 8px;
    }
    &-btn {
        margin-top: auto;
        transform: scale(0.65);
        transform-origin: bottom center;
        &.button-5 {
            p {
                color: #75777e;
            }
        }

        p {
            font-weight: bold;
            font-size: 29px;
            color: #8f4726;
            margin-top: 2px;
        }
    }
}

.bottom-tip {
    margin-top: 40px;
    font-size: 20px;
    color: rgba(235, 245, 255, 0.4);
    line-height: 30px;
    text-align: center;
    font-family: '黑体';
}
</style>
